import ProjectItem from '../components/ProjectItem';
import shoppingCart from '../assets/shoppingCart.PNG';
import randomRecipeApp from '../assets/randomRecipeApp.PNG';
import loginRegister from '../assets/loginRegister.PNG';
import passwordValidation from '../assets/passwordValidation.PNG';
import movieApp from '../assets/movieApp.PNG';
import weatherApp from '../assets/weatherApp.PNG';
import todo from '../assets/todo.PNG';
import ticTacToe from '../assets/ticTacToe.PNG';
import calculator from '../assets/calculator.PNG'

export const ProjectList = [
    {
      name: "Shopping Cart",
      image: shoppingCart,
      skills: "JavaScript,HTML,CSS",
    },
    {
      name: "Random recipe app",
      image: randomRecipeApp,
      skills: "JavaScript,HTML,CSS",
    },
    {
      name: "Login Register",
      image: loginRegister,
      skills: "React.js,HTML,CSS",
    },
    {
      name: "Password Validation",
      image: passwordValidation,
      skills: "React.js,HTML,CSS",
    },
    {
      name: "Movie App",
      image: movieApp,
      skills: "React.js,HTML,CSS",
    },
    {
      name: "Weather App",
      image: weatherApp,
      skills: "React.js,HTML,CSS",
    },
    {
        name: "To Do",
        image: todo,
        skills: "JavaScript,HTML,CSS",
    },
    {
        name: "Tic Tac Toe",
        image: ticTacToe,
        skills: "JavaScript,HTML,CSS",
    },
    {
        name: "Calculator",
        image: calculator,
        skills: "JavaScript,HTML,CSS",
      },
  ];